/**
 * Lightweight QA API runtime schema helpers (P2-FE-001).
 * Prefer validating shapes at the boundary before mutating page state.
 */

export function isPlainObject(value) {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

/** @returns {{ ok: boolean, item: object|null, error?: string }} */
export function parseSummaryPayload(data) {
  const item = data?.item;
  if (!isPlainObject(item)) {
    return { ok: false, item: null, error: 'summary.item missing' };
  }
  return { ok: true, item };
}

/** @returns {{ ok: boolean, items: array, meta: object, error?: string }} */
export function parseListPayload(data, { requireMeta = true } = {}) {
  const items = Array.isArray(data?.items) ? data.items : null;
  if (!items) return { ok: false, items: [], meta: {}, error: 'items missing' };
  const meta = isPlainObject(data?.meta) ? data.meta : {};
  if (requireMeta && !isPlainObject(data?.meta)) {
    return { ok: false, items, meta: {}, error: 'meta missing' };
  }
  return {
    ok: true,
    items,
    meta: {
      page: Number(meta.page || 1),
      per_page: Number(meta.per_page || items.length || 25),
      total_count: Number(meta.total_count || items.length || 0),
      total_pages: Math.max(1, Number(meta.total_pages || 1)),
      ...meta,
    },
  };
}
